<template>
  <div>
    <slot />
  </div>
</template>
<script setup>
const route = useRoute();
const ids = ref([]);
const selectedId = ref(null);
const lastScrollTop = ref(0);

const props = defineProps({
  scrollMargin: {
    required: false,
    default: 145,
    type: [Number, String],
  },
  offset: {
    required: false,
    default: 148,
    type: [Number, String],
  },
});

onMounted(() => {
  if (process.browser) {
    document.querySelectorAll(".scrollactive-item").forEach((el) => {
      const id = el.getAttribute("data-id");
      // checkIntersection(id, el);
      el.addEventListener("click", scrollToView, false);
    });
    window.addEventListener("scroll", handleScroll, false);
  }
});

onBeforeUnmount(() => {
  if (process.browser) {
    document.querySelectorAll(".scrollactive-item").forEach((el) => {
      const id = el.getAttribute("data-id");
      el.removeEventListener("click", scrollToView, false);
    });
    window.removeEventListener("scroll", handleScroll);
  }
});
function handleScroll() {
  let topElement = null;
  var st = window.pageYOffset || document.documentElement.scrollTop;
  let isSelected = false;

  document.querySelectorAll(".scrollactive-item").forEach((el) => {
    const id = el.getAttribute("data-id");
    const containerEl = document.getElementById(id);
    if (containerEl) {
      const topData = containerEl.getBoundingClientRect();

      const viewportHeight = window.innerHeight;
      if (st > lastScrollTop.value && topData.top <= props.offset) {
        topElement = el;
      } else if (st < lastScrollTop.value && !isSelected) {
        if (
          (topData.top >= props.offset &&
            topData.top + props.offset <= viewportHeight &&
            topData.top >= 0) ||
          (topData.bottom >= viewportHeight &&
            topData.bottom <= topData.height + props.offset)
        ) {
          topElement = el;
          isSelected = true;
        }
      }
    }
  });
  if (topElement) {
    document.querySelectorAll(".scrollactive-item").forEach((el) => {
      el.classList.remove("is-active");
    });
    topElement.classList.add("is-active");
  }
  lastScrollTop.value = st <= 0 ? 0 : st;
}

// function checkIntersection(item, self) {
//   const observer = new IntersectionObserver(
//     (entries) => {
//       let topElement = null;
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           if (
//             !topElement ||
//             entry.boundingClientRect.top > topElement.boundingClientRect.top
//           ) {
//             topElement = entry.target;
//           }
//         }
//       });
//       console.log(topElement);

//       if (topElement) {
//         document.querySelectorAll(".scrollactive-item").forEach((el) => {
//           el.classList.remove("is-active");
//         });
//         self.classList.add("is-active");
//       }
//     },
//     {
//       root: null, // Use the viewport as the root
//       rootMargin: "-149px", // No margin for the root
//       threshold: 0.1,
//     }
//   );

//   observer.observe(document.getElementById(item));

//   observerArr.value.push(observer);
// }
function scrollToView(e) {
  document.querySelectorAll(".scrollactive-item").forEach((el) => {
    el.classList.remove("is-active");
  });
  const id = e.target.getAttribute("data-id");
  const containerEl = document.getElementById(id);
  e.target.classList.add("is-active");
  containerEl.style.scrollMarginTop = props.offset + "px";
  containerEl.scrollIntoView({
    behavior: "smooth",
  });
}
</script>
<style>
.scrollactive-item {
  @apply cursor-pointer;
}
</style>